import { http } from "@/apis";
import type {
  ApiKey,
  CreateApiKeyRequest,
  RegenerateApiKeyResponse,
  UpdateApiKeyRequest,
} from "@/features/users/schemas/user";

type ApiSuccess<T> = { success: true; message: string; data: T };

export async function getApiKeysByUser(uid: string): Promise<ApiKey[]> {
  const response = await http.get<ApiSuccess<ApiKey[]>>(`/api/v1/apikeys/user/${uid}`);
  return response.data;
}

export async function createApiKey(data: CreateApiKeyRequest): Promise<ApiKey> {
  const response = await http.post<ApiSuccess<ApiKey>>("/api/v1/apikeys", data);
  return response.data;
}

export async function updateApiKey(
  id: string,
  data: UpdateApiKeyRequest
): Promise<ApiKey> {
  const response = await http.patch<ApiSuccess<ApiKey>>(`/api/v1/apikeys/${id}`, data);
  return response.data;
}

export async function regenerateApiKey(id: string): Promise<RegenerateApiKeyResponse> {
  const response = await http.post<ApiSuccess<RegenerateApiKeyResponse>>(
    `/api/v1/apikeys/${id}/regenerate`
  );
  return response.data;
}

export async function deleteApiKey(id: string): Promise<void> {
  await http.delete<ApiSuccess<void>>(`/api/v1/apikeys/${id}`);
}
